/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 7.71 12.73',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><g data-name="Layer 2"><g data-name="Layer 1-2" _fill="#fff"><path pid="0" d="M6.36 7.73L0 1.37 1.35 0l6.36 6.37z"/><path pid="1" d="M7.71 6.37l-6.36 6.36L0 11.38 6.36 5z"/></g></g></g></g>'
  }
})
